import { GAME_VARIANT_LABEL_MAP } from "@/src/constants/StatsCornerConstants";
import styles from "../Stats.module.css";
import gameAssets from "@themed-assets";
import { PlayingCards } from "./PlayingCards";
import {
  dateFormatter,
  formatINRCurrency,
} from "../../../../Common/utils/statsUtil";
import { isA23 } from "../Stats";
export const TopHands = ({ bestHands }) => {
  return (
    <>
      {bestHands && bestHands.length > 0 && (
        <div className="top-5-hands-section mt-4">
          <div className={`text-primary font-medium mb-[14px]`}>
            Top 5 Hands
          </div>
          <div className="flex flex-col gap-[14px]">
            {bestHands.map((item) => {
              return Object.keys(item).length ? (
                <div
                  key={item?.sno}
                  className={`${styles.coreCardConfigBkNoBorder} px-[16px] pt-[8px] pb-[12px] flex flex-col gap-[8px]`}
                >
                  <div className="blind-variant-info flex justify-between items-center">
                    <div className="variant-blind-info flex items-center gap-1">
                      <div className={`${styles.variantLabel}`}>
                        {GAME_VARIANT_LABEL_MAP[item?.gameVariant]?.shortLabel}
                      </div>
                      <img src={gameAssets.ChipsStackIcon} />
                      <div
                        className={`blinds-info font-medium text-xs text-primary`}
                      >
                        {item?.smallBlind}/{item?.bigBlind}
                      </div>
                    </div>
                    <div className="date-info">
                      <div className="text-xs font-normal text-secondary">
                        {dateFormatter(item)}
                      </div>
                    </div>
                  </div>

                  <div
                    className={`${
                      isA23 ? styles.gradientSeaBorder : styles.addaCardBorder
                    }`}
                  ></div>

                  <div className="win-cards-info grid grid-cols-3 items-center">
                    <div className="payout-info flex flex-col">
                      <div className="pot-info">
                        <span className="font-bold text-sm text-focus">
                          {formatINRCurrency(item?.potAmt)}
                        </span>
                        &nbsp;
                        <span className="font-normal text-xs text-secondary">
                          ({Math.floor(item?.potAmt / item?.bigBlind)}BB)
                        </span>
                      </div>
                      <div className="payout text-xs font-normal text-secondary break-all">
                        {item?.handRank ? item?.handRank : "-"}
                      </div>
                    </div>
                    <div className="my-cards flex flex-col gap-1 items-center">
                      <PlayingCards cards={item?.holeCards} />
                      <div className="text-xs font-medium text-primary">
                        My Cards
                      </div>
                    </div>
                    <div className="community-cards flex flex-col gap-1 items-center">
                      <PlayingCards
                        cards={item?.communityCards}
                        isCommunity={true}
                      />
                      <div className="text-xs font-medium text-primary">
                        Community Cards
                      </div>
                    </div>
                  </div>
                </div>
              ) : null;
            })}
          </div>
        </div>
      )}
    </>
  );
};
